import { Api } from "../api/api";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { AlertController } from "ionic-angular";

@Injectable()
export class VideoProvider {
  private url: string = "me/profile_movies";

  constructor(
    public http: HttpClient,
    public api: Api,
    public alertCtrl: AlertController
  ) {}

  post(videoData: any): Observable<any> {
    const formData: FormData = new FormData();
    const blobImage: Blob = this.toBlob(videoData);
    formData.append("video", blobImage, videoData.name);
    return this.api.post(this.url, formData);
  }

  put(videoId: number, param: string): Observable<any> {
    return this.api.put(this.url + "/" + videoId, { disclose: param });
  }

  delete(videoId: number): Observable<any> {
    return this.api.delete(this.url + "/" + videoId);
  }

  toBlob(base64: string): Blob {
    const bin = atob(base64.replace(/^.*,/, ""));
    let buffer = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    const blob = new Blob([buffer.buffer], { type: "video/mp4" });
    return blob;
  }

  showUploadError(error: any) {
    console.log(error);
    const alert = this.alertCtrl.create({
      title: "エラー",
      subTitle: "動画のアップロードに失敗しました",
      buttons: [
        {
          text: "OK",
        },
      ],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/video/video.ts